<template>
<v-app>
    <v-snackbar v-model="snackbar" top color="red" :timeout="4000">
        {{ errorMsg }}
        <v-btn color="white" icon @click="snackbar = false">
            <v-icon>mdi-close</v-icon>
        </v-btn>
    </v-snackbar>
    <v-container fluid class="mt-1">
        <v-card class="mx-10">
            <v-card-title>
              <v-img style="max-width: 250px" src="@/assets/logo-bmci.png"></v-img>
                <v-spacer></v-spacer>
                Offre LEASE (+) Particuliers
            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-col>
                        <v-simple-table dense>
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th>Apport</th>
                                        <th>Duree</th>
                                        <th>Loyer</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <template v-for="(offre,index) in offres">
                                        <tr :key="index" v-if="selectedApport == (offre.niveauApport)">
                                            <td>{{offre.niveauApport}} %</td>
                                            <td>{{offre.duree}}</td>
                                            <td>{{FormatPrix(CalculeLoyer(offre))}}</td>
                                        </tr>
                                    </template>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </v-container>
</v-app>
</template>

<script>
export default {
    name: "LoaBMCIParticuliers",
    data() {
        return {
            offres: [],
            snackbar: false,
            errorMsg: ''
        }
    },
    mounted() {
        this.getOffres()
    },
    methods: {
        getOffres: function () {
            let params = {}
            params.action = 'getOffres'
            params.type = 'bmci'
            params.name = 'loaparticuliers'
            this.axios.post(this.$store.state.rootUrl + 'apiSalesTarifier.php', params)
                .then(data => {
                    this.offres = data.data
                })
                .catch(error => {
                    this.errorMsg = 'Oups Erreur Serveur. Veuillez réessayer dans quelques instants'
                    this.snackbar = true
                    console.log(error)
                })
        },
        CalculeLoyer: function (offre) {
            let r = offre.taux / 1200
            let prixht = this.montant / 1.2
            let dg = offre.dg * this.montant
            let plm = (offre.plm * this.montant) / 1.2
            let coef = (1 - Math.pow((1 + r), (-offre.duree + 1))) / r
            let Loyer = ((prixht - dg - ((dg / 1.2) - dg) * Math.pow((1 + r), -offre.duree) - plm) / coef)
            let FraisAdi = this.montant * (1 - (offre.niveauApport / 100)) * ((0.06 / 100) * 1.1)
            Loyer = (Loyer * 1.2) + FraisAdi
            return Loyer.toFixed(2)
        },
        FormatPrix: function (prix) {
            return new Intl.NumberFormat('de-DE', {
                style: 'decimal',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }).format(prix)
        }
    },
    computed: {
        montant() {
            return this.$store.state.simulateur.montant
        },
        selectedApport() {
            return this.$store.state.simulateur.selectedApport
        }
    }
}
</script>
